import { cartFieldsQuery } from './getCart'
import { recommendedFieldsQuery } from './recommendations'
import { gql } from './gql'

/**
 * The basket the backend proposes, as lines with quantities.
 *
 * `prefillCart` exists twice in the schema — a query that *proposes* and a
 * mutation that *applies*. The query is the honest source for "Sugerido para
 * ti": it is the storefront's own answer to "what should this shopper reorder",
 * where the previous implementation took the first three products of the
 * catalog and made up the quantities.
 */
export const GET_PREFILL_CART = gql`
  query PrefillCart($storefrontName: String!, $sessionUid: String!, $limit: Int) {
    prefillCart(storefrontName: $storefrontName, sessionUid: $sessionUid, limit: $limit) {
      ${recommendedFieldsQuery}
    }
  }
`

/**
 * Applies a whole basket in one call, and returns the cart it produced.
 *
 * The alternative is one `cartAddProduct` per line, which is what "Agregar
 * todo" used to do: five lines meant five mutations racing each other, five
 * recalculations of the same cart, and a promotion engine that saw four
 * intermediate carts nobody ever had.
 *
 * `replaceCart: false` on purpose — the shopper is adding a suggestion to what
 * they already have. `true` is the "start this order from last week's" flow,
 * which is not what this button says.
 */
export const PREFILL_CART = gql`
  mutation PrefillCart(
    $storefrontName: String!
    $sessionUid: ID!
    $items: [CartProductInput]
    $replaceCart: Boolean
  ) {
    prefillCart(
      storefrontName: $storefrontName
      sessionUid: $sessionUid
      items: $items
      replaceCart: $replaceCart
    ) {
      ${cartFieldsQuery}
    }
  }
`
